<!-- manage-subscription-dialog.component.html -->
<h2 mat-dialog-title>Dettagli richiesta</h2>

<mat-dialog-content>
  <p>Questa richiesta è {{ getReferralStatusDisplay(referralRequest.status) }}.</p>

  <div *ngIf="isLoading" class="text-center mt-3">
    <mat-spinner diameter="30"></mat-spinner>
    <p class="mt-2">Aggiornamento in corso...</p>
  </div>

  <mat-divider></mat-divider>

  <p class="mt-3">I dati che hai inserito:</p>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Nome:</mat-label>
    <input
      matInput 
      [value]="referralRequest.name" 
      readonly
      #linkInput>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Indirizzo mail</mat-label>
    <input
      matInput 
      [value]="referralRequest.mail" 
      readonly
      #linkInput>
    <button 
      mat-icon-button 
      matSuffix 
      (click)="copyMailToClipboard()"
      [attr.aria-label]="'Copia link'">
      <mat-icon>content_copy</mat-icon>
    </button>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Telefono/cellulare:</mat-label>
    <input 
      matInput 
      [value]="referralRequest.telephone" 
      readonly
      #linkInput>
    <button 
      mat-icon-button 
      matSuffix 
      (click)="copyNumberToClipboard()"
      [attr.aria-label]="'Copia numero'">
      <mat-icon>content_copy</mat-icon>
    </button>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>È già una Partita Iva?</mat-label>
    <input 
      matInput 
      [value]="referralRequest.is_already_partita_iva ? 'Sì' : 'No'"  
      readonly
      #linkInput>
  </mat-form-field>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <!-- <button mat-button mat-dialog-close [disabled]="isLoading">Indietro</button> -->
  <button 
    mat-raised-button 
    color="primary" 
    (click)="confirm()"
    [disabled]="isLoading || referralForm.invalid"
  >
    <mat-icon>check</mat-icon>
    Fatto
  </button>
</mat-dialog-actions>
